import Tooltip from 'components/tooltip/Tooltip';
import Button from 'components/button/Button';
import PencilSquareIcon from 'assets/images/icons/pencil-square.svg?react';
import { useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import { Row } from '@tanstack/react-table';
import { GuestReviewTemplate } from 'models/automation/Reviews';
import useAddEditReviewTemplateModal from '../../modal/useAddEditReviewTemplateModal';
import useDeleteReviewTemplateModal from '../../modal/delete/useDeleteReviewTemplateModal';

const ActionsCell = ({ row }: { row: Row<GuestReviewTemplate> }) => {
  const { t } = useTranslation();
  const { openEditReviewTemplateModal } = useAddEditReviewTemplateModal();
  const { openDeleteReviewTemplateModal } = useDeleteReviewTemplateModal();

  const handleEditModal = () => {
    openEditReviewTemplateModal({
      reviewTemplateUid: row.original.uid,
    });
  };

  const handleDeleteModal = () => {
    openDeleteReviewTemplateModal(row.original);
  };

  return (
    <div>
      <Tooltip id="row-edit-review-template-button" text={t('common.edit')}>
        <Button
          bsStyle="link"
          data-testid="row-edit-review-template-button"
          onClick={handleEditModal}
        >
          <PencilSquareIcon aria-label={t('common.edit')} />
        </Button>
      </Tooltip>

      <Tooltip id="row-delete-review-template-button" text={t('common.delete')}>
        <Button
          bsStyle="link"
          data-testid="row-delete-review-template-button"
          onClick={handleDeleteModal}
        >
          <Glyphicon glyph="trash" aria-label={t('common.delete')} />
        </Button>
      </Tooltip>
    </div>
  );
};

export default ActionsCell;
